import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiCheck } from 'react-icons/fi';

// Sample names and professions for realistic notifications
const registrationData = [
  { name: "Rajesh Kumar", profession: "Business Owner" },
  { name: "Arun Karthik", profession: "Coach" },
  { name: "Priya Sharma", profession: "Consultant" },
  { name: "Vijay Anand", profession: "Entrepreneur" },
  { name: "Lakshmi Devi", profession: "Healer" },
  { name: "Karthik Raja", profession: "Freelancer" },
  { name: "Divya Menon", profession: "Sales Professional" },
  { name: "Suresh Babu", profession: "Marketer" },
  { name: "Meera Krishnan", profession: "Business Owner" },
  { name: "Arjun Singh", profession: "Coach" },
  { name: "Sneha Reddy", profession: "Consultant" },
  { name: "Ramesh Kumar", profession: "Entrepreneur" },
  { name: "Anitha Iyer", profession: "Working Professional" },
  { name: "Ganesh Moorthy", permission: "Business Owner" },
  { name: "Kavitha Nair", profession: "Coach" }
];

/**
 * Recent Registrations Notification Component
 * Shows random registration notifications every 5 seconds
 */
export default function RecentRegistrations() {
  const [currentRegistration, setCurrentRegistration] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Function to show a random registration
    const showRandomRegistration = () => {
      // Pick a random registration from the list
      const randomIndex = Math.floor(Math.random() * registrationData.length);
      const registration = registrationData[randomIndex];
      
      setCurrentRegistration(registration);
      setIsVisible(true);

      // Hide after 4 seconds (will show new one after 5 seconds total)
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };

    // Show first notification after 3 seconds
    const initialTimeout = setTimeout(() => {
      showRandomRegistration();
    }, 3000);

    // Show new notification every 5 seconds
    const interval = setInterval(() => {
      showRandomRegistration();
    }, 5000);

    // Cleanup
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);

  return (
    <AnimatePresence>
      {isVisible && currentRegistration && (
        <motion.div
          className="recent-registration-notification"
          initial={{ opacity: 0, x: -100, y: 0 }}
          animate={{ opacity: 1, x: 0, y: 0 }}
          exit={{ opacity: 0, x: -100, y: 0 }}
          transition={{
            type: "spring",
            stiffness: 200,
            damping: 20
          }}
        >
          <div className="notification-icon">
            <FiCheck />
          </div>
          <div className="notification-content">
            <div className="notification-name">{currentRegistration.name}</div>
            <div className="notification-text">
              <span className="profession">{currentRegistration.profession}</span> registered for this workshop
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}